import React, { useEffect, useState } from 'react';
import _ from 'underscore';
import axios from "axios";
import setting from '../../config/setting'
import { Spin, Space, Row, Col } from 'antd';
import moment from 'moment';
import { Card, Form, Input, Select, Timeline, Table } from 'antd';
import {
  UserOutlined,
} from '@ant-design/icons/lib';
import { useGetDoctor } from '../../hooks/useGetDoctor';
import { IPageData } from '../../interfaces/page';
import { IUser } from '../../interfaces/user';

const pageData: IPageData = {
  title: 'Customer details',
  fulFilled: true,
  breadcrumbs: [
    {
      title: 'Medicine',
      route: 'default-dashboard'
    },
    {
      title: 'Doctors',
      route: 'default-dashboard'
    },
    {
      title: 'Dr.Sophie'
    }
  ]
};
{/* <span className='text-base text-color-100'>{childData.street} , {childData.city} , {childData.state_id[1]} , {childData.zip}</span>
<span>{childData.contact1_emp ? childData.contact1_emp[1] : ''}</span>
<p>{childData.phone}</p> */}

const colNew = [

  {
    title: 'Reason',
    key: 'reasons',
    dataIndex: 'reasons',


    sorter: (a, b) => a.reasons.length - b.reasons.length,
    // sorter: (a, b) => (a.name > b.name ? 1 : -1),
    render: (reasons) => <div
      //onClick={()=>handleShowInfo} 
      style={{ cursor: 'pointer' }}><span>{reasons}</span></div>
  },
  {
    title: 'Packages',
    key: 'packages',
    dataIndex: 'packages',


    sorter: (a, b) => a.packages[1].length - b.packages[1].length,
    // sorter: (a, b) => (a.name > b.name ? 1 : -1),
    render: (packages) => <div
      //onClick={()=>handleShowInfo} 
      style={{ cursor: 'pointer' }}><span>{packages[1]}</span></div>
  },
  {
    title: 'Laboratory',
    key: 'laboratory',
    dataIndex: 'laboratory',


    sorter: (a, b) => a.laboratory[1].length - b.laboratory[1].length,
    // sorter: (a, b) => (a.name > b.name ? 1 : -1),
    render: (laboratory) => <div
      //onClick={()=>handleShowInfo} 
      style={{ cursor: 'pointer' }}><span>{laboratory[1]}</span></div>
  },
  {
    title: 'Description',
    key: 'description',
    dataIndex: 'description',


    sorter: (a, b) => a.description.length - b.description.length,
    // sorter: (a, b) => (a.name > b.name ? 1 : -1),
    render: (description) => <div
      //onClick={()=>handleShowInfo} 
      style={{ cursor: 'pointer' }}>{description == false ? '' : description} </div>
  },
  {
    title: 'Protocol',
    key: 'protocol',
    dataIndex: 'protocol',


    sorter: (a, b) => a.protocol.length - b.protocol.length,
    // sorter: (a, b) => (a.name > b.name ? 1 : -1),
    render: (protocol) => <div
      //onClick={()=>handleShowInfo} 
      style={{ cursor: 'pointer' }}>{protocol == false ? '' : protocol}</div>
  },


]

const colPool = [

  {
    title: 'Pool Name',
    key: 'pool_name',
    dataIndex: 'pool_name',


    sorter: (a, b) => a.pool_name.length - b.pool_name.length,
    // sorter: (a, b) => (a.name > b.name ? 1 : -1),
    render: (pool_name) => <div
      //onClick={()=>handleShowInfo} 
      style={{ cursor: 'pointer' }}>{pool_name == false ? '' : pool_name}</div>
  },
  {
    title: 'Company',
    key: 'company',
    dataIndex: 'company',


    sorter: (a, b) => a.company[1].length - b.company[1].length,
    // sorter: (a, b) => (a.name > b.name ? 1 : -1),
    render: (company) => <div
      //onClick={()=>handleShowInfo} 
      style={{ cursor: 'pointer' }}>{company ? company[1] : ''}</div>
  },
  {
    title: 'Company Type',
    key: 'company_type',
    dataIndex: 'company_type',


    sorter: (a, b) => a.company_type.length - b.company_type.length,
    // sorter: (a, b) => (a.name > b.name ? 1 : -1),
    render: (company_type) => <div
      //onClick={()=>handleShowInfo} 
      style={{ cursor: 'pointer' }}>{company_type ? company_type : ''}</div>
  },
  {
    title: 'Program',
    key: 'program',
    dataIndex: 'program',


    sorter: (a, b) => a.program.length - b.program.length,
    // sorter: (a, b) => (a.name > b.name ? 1 : -1),
    render: (program) => <div
      //onClick={()=>handleShowInfo} 
      style={{ cursor: 'pointer' }}><strong>{program == false ? '' : program}</strong></div>
  },
  {
    title: 'Mode',
    key: 'Mode',
    dataIndex: 'Mode',


    sorter: (a, b) => a.Mode.length - b.Mode.length,
    // sorter: (a, b) => (a.name > b.name ? 1 : -1),
    render: (Mode) => <div
      //onClick={()=>handleShowInfo} 
      style={{ cursor: 'pointer' }}><strong>{Mode == false ? '' : Mode}</strong></div>
  },

]

const columnsNew = [

  {
    key: 'name',
    dataIndex: 'name',
    title: 'Name',
    // sorter: (a, b) => (a.name > b.name ? 1 : -1),
    render: (name) => <strong>{name}</strong>
  },
  {
    title: 'Address',
    key: 'street',
    dataIndex: ['street', 'city', 'state_id', 'zip'],


    //sorter: (a, b) => a.contact1_emp.length - b.contact1_emp.length,
    // sorter: (a, b) => (a.name > b.name ? 1 : -1),
    render: (text, row) => <div
      //onClick={()=>handleShowInfo} 
      style={{ cursor: 'pointer' }}><strong>{row["street"]},{row["city"]},{row["state_id[1]"]} {row["zip"]}</strong></div>
  },

  {
    title: 'Contact Person',
    key: 'contact1_emp',
    dataIndex: 'contact1_emp',


    sorter: (a, b) => a.contact1_emp.length - b.contact1_emp.length,
    // sorter: (a, b) => (a.name > b.name ? 1 : -1),
    render: (contact1_emp) => <div
      //onClick={()=>handleShowInfo} 
      style={{ cursor: 'pointer' }}><strong>{contact1_emp[1] ? contact1_emp[1].split(',')[1] : ''}</strong></div>
  },
  {
    title: 'Phone Number',
    key: 'phone',
    dataIndex: 'phone',


    sorter: (a, b) => a.phone.length - b.phone.length,
    // sorter: (a, b) => (a.name > b.name ? 1 : -1),
    render: (phone) => <div
      //onClick={()=>handleShowInfo} 
      style={{ cursor: 'pointer' }}><strong>{phone}</strong></div>
  },
]

const columns = [
  // {
  //   key: 'id',
  //   dataIndex: 'id',
  //   title: 'ID',
  //   sorter: (a, b) => (a.id > b.id ? 1 : -1),
  //   render: (id) => (
  //     <span className='nowrap'>
  //       {id}
  //     </span>
  //   )
  // },
  {
    key: 'emp_ssn',
    dataIndex: 'emp_ssn',
    title: 'Employee SSN',
    // sorter: (a, b) => (a.name > b.name ? 1 : -1),
    render: (emp_ssn) => <strong>{emp_ssn}</strong>
  },
  {
    title: 'Name',
    key: 'display_name',
    dataIndex: 'display_name',


    sorter: (a, b) => a.display_name.length - b.display_name.length,
    // sorter: (a, b) => (a.name > b.name ? 1 : -1),
    render: (display_name) => <div
      //onClick={()=>handleShowInfo} 
      style={{ cursor: 'pointer' }}><strong>{display_name}</strong></div>
  },
  {
    key: 'Sex',
    dataIndex: 'Sex',
    title: 'Gender',
    sorter: (a, b) => a.Sex.length - b.Sex.length,
    // sorter: (a, b) => (a.name > b.name ? 1 : -1),
    render: (Sex) => <strong>{Sex}</strong>
  },

  {
    key: 'dob',
    dataIndex: 'dob',
    title: 'D.O.B',

    // sorter: (a, b) => a.age - b.age,
    sorter: (a, b) => moment(a.dob).unix() - moment(b.dob).unix(),
    render: (dob) => (
      <span className='nowrap'>
        <strong> {dob ? moment(dob).format("MM/DD/YYYY") : ''}</strong>
      </span>
    )
  },
  {
    key: 'company',
    dataIndex: 'company',
    title: 'Company Name',
    sorter: (a, b) => a.company[1].length - b.company[1].length,
    render: (company) => <strong>{company[1]}</strong>
  },
  {
    key: 'emp_status',
    dataIndex: 'emp_status',
    sorter: (a, b) => a.emp_status.length - b.emp_status.length,
    title: 'Status',
    render: (emp_status) =>
      emp_status == 'active' ?
        <strong style={{ color: 'green' }}>{emp_status}</strong>
        : emp_status == 'terminated' ?
          <strong style={{ color: 'red' }}>{emp_status}</strong>
          : <strong style={{ color: 'blue' }}>{emp_status}</strong>

  },


  {
    key: 'emp_location',
    dataIndex: 'emp_location',
    //sorter: (a, b) => a.emp_location[1] && b.emp_location[1] ? a.emp_location[1].length - b.emp_location[1].length : 0,
    title: 'Location',
    render: (emp_location) => <strong>{emp_location[1]}</strong>
  }

];



const FormItem = Form.Item;
const Option = Select.Option;

type DoctorFormProps = { doctor: Partial<IUser> };

const DoctorForm = ({ doctor }) => {



  return (
    <div style={{ padding: 20, backgroundColor: "#fff", borderRadius: 20 }}>
      <a target="_blank" href={doctor.website}>{doctor.website}</a>
      <Form layout='vertical'>
        <FormItem label='Name'>
          <Input defaultValue={doctor.name} readOnly placeholder='Name' />
        </FormItem>

        <FormItem label='Street'>
          <Input defaultValue={doctor.street} readOnly placeholder='Street' />
        </FormItem>

        <div className='row'>
          <div className='col-md-6 col-sm-12'>
            <FormItem label='City'>
              <Input defaultValue={doctor.city} readOnly placeholder='City' />
            </FormItem>
            <FormItem label='State'>
              <Input defaultValue={doctor.state_id[1]} readOnly placeholder='State' />
            </FormItem>

          </div>
          <div className='col-md-6 col-sm-12'>
            <FormItem label='Zip'>
              <Input defaultValue={doctor.zip} readOnly placeholder='Zip' />
            </FormItem>
            <FormItem label='Phone Number'>
              <Input defaultValue={doctor.phone} readOnly placeholder='Phone Number' />
            </FormItem>


          </div>
        </div>
        <FormItem label='Email'>
          <Input defaultValue={doctor.email} readOnly placeholder='Email' />
        </FormItem>

      </Form>
    </div>
  );
};

const DocTimeline = ({ dataParentToChild }) => (
  <div style={{ backgroundColor: "#fff", borderRadius: 20 }}>
    <h4 style={{ textAlign: 'left', color: '#8f8f90', padding: 20, marginTop: "auto" }}>Contacts:</h4>
    <div style={{ marginLeft: 20, height: '420px', overflowY: 'scroll' }}>
      <Timeline
        //mode='right'
        style={{ marginLeft: 10 }}
      >


        {dataParentToChild.map((childData, index) => (

          <Timeline.Item
            dot={
              <div className='p-2 bg-color-indigo rounded-full' style={{ marginTop: 5 }}>
                <UserOutlined className='text-contrast-500' />

              </div>
            }
          >
            <div className='d-flex flex-column' style={{ padding: 10 }}>
              <div>
                <img src={childData.image_128 == "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"
                  || childData.image_128 == false
                  ?
                  "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAOEAAADhCAMAAAAJbSJIAAAALVBMVEX////CwsLh4eG9vb3w8PD5+fni4uLt7e3n5+f7+/v19fXl5eXq6ury8vLd3d1IURIqAAAEM0lEQVR4nO2dgbKqIBRFuyUqpv3/5770IAcxJ1Owtm+vmTvzlFTWO3AETbv8nZ3LtyuQnd7wdl7E8HY5LzcawkNDfGiIDw3xoSE+NMSHhvjQEB8a4kNDfGiIDw3xoSE+NMSHhvjQEB8aekzxDpu+dm8Pat7vY7VhcX3DY8XRPuXtQYv3+0hneKXhBmhIwx4arj9Yllz6+ILh/mongYYKDT00PBgaKjT00PBgaKjQ0EPDg6GhQkMPDQ+GhgoNPTQ8GBoqNPTQ8GByGMrl58f+yiXB1SaloTXC/solwdVmxX1n3sfHh4b40BAfGuJDQ3xoiA8N8aEhPjTEh4b40BAfGuJDQ3xoiA8N19HWT7oXBbbpi6rmRVFTDRvNi0zXb9OlusuVxrDsb+ZVs9W29c+8VNMKm0qfhpk+mmnu4/pyxc3BFeQ07MqrUjZLJdd7oFiFBXWKOGY0jJ6UKrUVN9OSa+0V22ibBIr5DDsXoGefchEbo9jIcln7otqVOEEtSPC1gWyGduhPZdWHx0jbu7si8WiH+DR1IG+CYBspmHfuT8lmKG10TBbVzGMMmxXd4d9tGGpbp2mnuQwlhK1frjWI9bT5FX5RWq/PoJJVdwcxl6GZ9DzXKyUg16m77XvdENHBNUis7TQLbSSXYRXlCTN8pO9h0iyD4YF1f85ICyRX/aph0CoHrG9ycqp40b1s3Cpt1A62kcsw6oZOuV8h7fVFZGwZBfcSR3sTuQxna7xh3Ns885BN0vFWjjes1FDHNg+7aLg3mX7XUIenoIbL/fADw19tpXWU+WVF/5HgHBCMwO2YSwOh2XllE7kMZQCmy1r9YCxgu6LoKm/ow+xYPK98RC7D+Gw9NEiZIz6mobL+k9JDdR9Bj91BtnFptCqobTQuNd5QzpTaEWfn1E1km1sMzdTPDEyQebppAlFDacm+83ZJumE+Q8mTbtwsEXVvP3Ezx7HqjbZnmWa04Q52N9KUhu34VXD5NribrxfPJXfxZfwvGGf/3bOoa69qeHGT/2dB49bvHZUmNQzoo2Xv0crFqzHaLZt4R7t7YS7DIcWbqWI40aujj5fRJZyEgjkNnwlU15fTynahvVzMEWwdbLM7y/SkMYwFxzcqmUpSaj17OZ4tWrkOU7fR1e2mkrll26V5iV8aQxOjRX36sS/rOiSmV0V25bMi6+CdGXxoiA8N8aEhPjTEh4b40BAfGuJDQ3xoiA8N8aEhPjT0jD9qk79Kq8j3Szq/9SYsvs2sh4YeGh4MDRUaemh4MDRUaOih4cHQUKGhh4YHQ0OFhh4aHgwNFRp6aHgwGQ0XOc3vAS9z+t90puEWaEjDnh/PpUcajndIl0n2HM8HB015hxQWGuJDQ3xoiA8N8aEhPjTEh4b40BAfGuJDQ3xoiA8N8aEhPjTEh4b40BCf/8Xw73Ze/sTw3Jzf8B+89zsx8QEiSQAAAABJRU5ErkJggg=="
                  :
                  "data:image/png;base64," + childData.image_128
                } style={{
                  width: '18%', borderRadius: '50px', padding: 5, border: '1px solid grey'
                }} />
              </div>
              <h3 className='m-0'>{childData.name}</h3>

              <span className='text-base text-color-100'>{childData.street} , {childData.city} , {childData.state_id[1]} , {childData.zip}</span>
              <span>{childData.contact1_emp ? childData.contact1_emp[1] : ''}</span>
              <p>{childData.phone}</p>

            </div>
          </Timeline.Item>
        ))}


      </Timeline>
    </div>
  </div>
);

const ProtocolForm = ({ protValue }) => (
  <div>
    <Row>
      <Col span={12}>
        <h5 style={{ textAlign: 'left' }}>Physicals</h5>
        <p>Authorization : <b>{protValue.authorization}</b></p>
        <p>Documentation : <b>{protValue.documentation}</b></p>
      </Col>
      <Col span={10}>
        <h5 style={{ textAlign: 'left' }}> Drug and Alcohol Testing</h5>
        <p>Authorization : <b>{protValue.authorization_drug}</b></p>
        <p>Documentation : <b>{protValue.documentation_drug}</b></p>


      </Col>
    </Row>
    <Row>
      <Col span={12}>
        <h4 style={{ textAlign: 'left' }}>Contact Information</h4>
      </Col>

    </Row>
    <Row>
      <Col span={10}>
        <h5 style={{ textAlign: 'left' }}>Physicals</h5>
        <p>Consortium / Third - Party Administrator(C / TPA) : <b>{protValue.consortium}</b></p>
        <p>Authorizing Party - Physicals : <b>{protValue.authorizing_party}</b></p>
        <p>Medical Review Officer : <b>{protValue.medical}</b></p>
      </Col>
      <Col span={6}>
        <h5 style={{ textAlign: 'left' }}>Invoice</h5>
        <p>Physicals : <b>{protValue.physicals}</b></p>
        <p>Alcohol & Testing Drug : <b>{protValue.alcohol}</b></p>


      </Col>
    </Row>
  </div>
)

const DocTimelineNew = ({ dataParentToChild }) => (
  <div>
    <h4 style={{ textAlign: 'left', color: '#8f8f90', marginLeft: 10, marginTop: 30 }}>Locations:</h4>
    <div style={{ marginLeft: 20, height: '480px', overflowY: 'scroll' }}>
      <Timeline
        //mode='right'
        style={{ marginLeft: 10 }}
      >


        {dataParentToChild.map((childData, index) => (

          <Timeline.Item
            dot={
              <div className='p-2 bg-color-indigo rounded-full'>
                <UserOutlined className='text-contrast-500' />

              </div>
            }
          >
            <div className='d-flex flex-column'>
              <div>
                <img src={childData.image_128 == "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"
                  || childData.image_128 == false
                  ?
                  "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAOEAAADhCAMAAAAJbSJIAAAALVBMVEX////CwsLh4eG9vb3w8PD5+fni4uLt7e3n5+f7+/v19fXl5eXq6ury8vLd3d1IURIqAAAEM0lEQVR4nO2dgbKqIBRFuyUqpv3/5770IAcxJ1Owtm+vmTvzlFTWO3AETbv8nZ3LtyuQnd7wdl7E8HY5LzcawkNDfGiIDw3xoSE+NMSHhvjQEB8a4kNDfGiIDw3xoSE+NMSHhvjQEB8aekzxDpu+dm8Pat7vY7VhcX3DY8XRPuXtQYv3+0hneKXhBmhIwx4arj9Yllz6+ILh/mongYYKDT00PBgaKjT00PBgaKjQ0EPDg6GhQkMPDQ+GhgoNPTQ8GBoqNPTQ8GByGMrl58f+yiXB1SaloTXC/solwdVmxX1n3sfHh4b40BAfGuJDQ3xoiA8N8aEhPjTEh4b40BAfGuJDQ3xoiA8N19HWT7oXBbbpi6rmRVFTDRvNi0zXb9OlusuVxrDsb+ZVs9W29c+8VNMKm0qfhpk+mmnu4/pyxc3BFeQ07MqrUjZLJdd7oFiFBXWKOGY0jJ6UKrUVN9OSa+0V22ibBIr5DDsXoGefchEbo9jIcln7otqVOEEtSPC1gWyGduhPZdWHx0jbu7si8WiH+DR1IG+CYBspmHfuT8lmKG10TBbVzGMMmxXd4d9tGGpbp2mnuQwlhK1frjWI9bT5FX5RWq/PoJJVdwcxl6GZ9DzXKyUg16m77XvdENHBNUis7TQLbSSXYRXlCTN8pO9h0iyD4YF1f85ICyRX/aph0CoHrG9ycqp40b1s3Cpt1A62kcsw6oZOuV8h7fVFZGwZBfcSR3sTuQxna7xh3Ns885BN0vFWjjes1FDHNg+7aLg3mX7XUIenoIbL/fADw19tpXWU+WVF/5HgHBCMwO2YSwOh2XllE7kMZQCmy1r9YCxgu6LoKm/ow+xYPK98RC7D+Gw9NEiZIz6mobL+k9JDdR9Bj91BtnFptCqobTQuNd5QzpTaEWfn1E1km1sMzdTPDEyQebppAlFDacm+83ZJumE+Q8mTbtwsEXVvP3Ezx7HqjbZnmWa04Q52N9KUhu34VXD5NribrxfPJXfxZfwvGGf/3bOoa69qeHGT/2dB49bvHZUmNQzoo2Xv0crFqzHaLZt4R7t7YS7DIcWbqWI40aujj5fRJZyEgjkNnwlU15fTynahvVzMEWwdbLM7y/SkMYwFxzcqmUpSaj17OZ4tWrkOU7fR1e2mkrll26V5iV8aQxOjRX36sS/rOiSmV0V25bMi6+CdGXxoiA8N8aEhPjTEh4b40BAfGuJDQ3xoiA8N8aEhPjT0jD9qk79Kq8j3Szq/9SYsvs2sh4YeGh4MDRUaemh4MDRUaOih4cHQUKGhh4YHQ0OFhh4aHgwNFRp6aHgwGQ0XOc3vAS9z+t90puEWaEjDnh/PpUcajndIl0n2HM8HB015hxQWGuJDQ3xoiA8N8aEhPjTEh4b40BAfGuJDQ3xoiA8N8aEhPjTEh4b40BCf/8Xw73Ze/sTw3Jzf8B+89zsx8QEiSQAAAABJRU5ErkJggg=="
                  :
                  "data:image/png;base64," + childData.image_128
                } style={{
                  width: '18%', borderRadius: '50px', padding: 5, border: '1px solid grey'
                }} />
              </div>
              <h3 className='m-0'>{childData.name}</h3>

              <span className='text-base text-color-100'>{childData.street} , {childData.city} , {childData.state_id[1]} , {childData.zip}</span>
              <span>{childData.contact1_emp ? childData.contact1_emp[1] : ''}</span>
              <p>{childData.phone}</p>

            </div>
          </Timeline.Item>
        ))}


      </Timeline>
    </div>
  </div>
);

const DoctorProfilePage = () => {

  const [count, setCount] = useState([]);
  const [countNew, setCountNew] = useState([]);
  const [dat, setDat] = useState('');
  const [loader, setLoader] = useState(false);
  const [locData, setLocData] = useState({});
  const [patArr, setPatArr] = useState([]);
  const [arrNewn, setArrNew] = useState([]);
  const [poolArr, setArrNewPool] = useState([]);

  const [allData, setallData] = useState([]);
  const [change, setChange] = useState(false);
  const [DataAll, setDataAll] = useState([]);
  const [DataAllTrue, setDataAllTrue] = useState(false);

  // const location = useLocation();
  // const data = (location.state as IState).data;



  useEffect(() => {

    // console.log("this.props", data);


    // getCustomerData(data)
    // //getEmployeeInfo(data)
    // getEmployeeInfo(data)
    // getProtcol(data)
    // getPool(data)
    getData()

  }, [])

  const getData = () => {
    
    let custIdArr = [];
    axios.post(setting.serverUrl + '/api/CustomerData', {
      params:
      {
        email: localStorage.getItem('myData'),
        user: localStorage.getItem('myData'),
        pass: localStorage.getItem('myPass')
      }
    }).then(response => {
      console.log("Respone from getData ", response.data)
      if(response && response.data.error){
        alert("Some Technical Error Occurred!")
      }

      if (response && response.status == 200) {

        _.each(response.data, (res) => {

          if (res.is_company) {
            custIdArr.push(res);
          }

        })

        // setSyntheticTrailingComments

        // this.setState({ allDataCust: custIdArr, change: true });
        setDataAll(custIdArr);
        setDataAllTrue(!DataAllTrue)
        setTimeout(() => {

          getCust(custIdArr);

          getCustomerData(custIdArr[0])
          //getEmployeeInfo(data)
          // getEmployeeInfo(custIdArr[0])
          // getProtcol(custIdArr[0])
          // getPool(custIdArr[0])

        }, 2000)

      }
    })
  }

  const getCust = (custIdArr) => {

    console.log("custIdArr::", custIdArr)

    let dat = [];
    axios.post(setting.serverUrl + '/api/employeeCustCustomerPortal', {
      //  axios.get('http://localhost:3001/api/employee',{
      params:
      {
        //email:localStorage.getItem('myData'),
        user: localStorage.getItem('myData'),
        pass: localStorage.getItem('myPass'),
        custIdArr:JSON.parse(localStorage.getItem('customerData')).employee_multi_select,
        compId: JSON.parse(localStorage.getItem('customerData')).id
      }
    }).then(response => {
      console.log("Respone from getData employeeCust", response.data)
      if(response && response.data.error){
        alert("Some Technical Error Occurred!")
      }
      if (response && response.status == 200) {


        // _.each(custIdArr, (id) => {

        //   _.each(response.data, (compData) => {

        //     if (id == compData.company[0]) {

        //       dat.push(compData);

        //     }
        //   })

        // })

        // console.log("dat", dat);
        setPatArr(response.data)
        setChange(true)
        // this.setState({ allData: response.data, change: true });

      }
    })

  }

  function getProtcol(data) {
    //setLoader(false);

    console.log("inside getProtcol");
    axios.post(setting.serverUrl + '/api/getProtcol', {
      // axios.get('http://localhost:3001/api/allCustomerData',{
      params:
      {
        email: localStorage.getItem('myData'),
        user: localStorage.getItem('myData'),
        pass: localStorage.getItem('myPass')
      }
    }).then(response => {
      console.log("Respone from getProtcol", response.data)
      if(response && response.data.error){
        alert("Some Technical Error Occurred!")
      }
      let arrNew = [];
      _.each(data.protocol_testing_multi_select, (dataId) => {

        _.each(response.data, (resp) => {

          if (dataId == resp.id) {
            arrNew.push(resp);

          }


        })


      })

      console.log("arrNew", arrNew);
      setArrNew(arrNew)

    })
  }

  function getPool(data) {
    //setLoader(false);

    console.log("inside getPool");
    axios.post(setting.serverUrl + '/api/getPool', {
      // axios.get('http://localhost:3001/api/allCustomerData',{
      params:
      {
        email: localStorage.getItem('myData'),
        user: localStorage.getItem('myData'),
        pass: localStorage.getItem('myPass')
      }
    }).then(response => {
      console.log("Respone from getPool", response.data)
      if(response && response.data.error){
        alert("Some Technical Error Occurred!")
      }
      let poolGen = [];
      _.each(data.pool_generated, (dataIds) => {

        _.each(response.data, (resp1) => {

          if (dataIds == resp1.id) {
            poolGen.push(resp1);

          }
        })
      })

      console.log("poolGen", poolGen);
      setArrNewPool(poolGen)

    })
  }

  function getCustomerData(data) {
    setLoader(false);

    console.log("inside getCustomerData", data);
    axios.post(setting.serverUrl + '/api/allCustomerData', {
      // axios.get('http://localhost:3001/api/allCustomerData',{
      params:
      {
        email: localStorage.getItem('myData'),
        user: localStorage.getItem('myData'),
        pass: localStorage.getItem('myPass')
      }
    }).then(response => {
      console.log("Respone from getCustomerData ", response.data)
      if(response && response.data.error){
        alert("Some Technical Error Occurred!")
      }
      let dataArr = [];
      let dataArrNew = [];
      //setTimeout(()=>{

      _.each(data.child_ids, (child) => {

        _.each(response.data, (allCustList) => {

          if (child == allCustList.id) {

            dataArr.push(allCustList)

          }
        })

      })

      _.each(data.child_ids_loc, (childs) => {

        _.each(response.data, (allCustLists) => {

          if (childs == allCustLists.id) {

            dataArrNew.push(allCustLists)

          }
        })

      })

      console.log("dataArrNew", dataArrNew);


      setCount(dataArr);
      setCountNew(dataArrNew);
      setDat(data.name);
      setLoader(true);
      setLocData(data)


    })

  }

  function getEmployeeInfo(data) {
    console.log("datatat", data);
    let custIdArr = [];
    axios.post(setting.serverUrl + '/api/employee', {
      // axios.get('http://localhost:3001/api/employee',{
      params:
      {
        email: localStorage.getItem('myData'),
        user: localStorage.getItem('myData'),
        pass: localStorage.getItem('myPass')
      }
    }).then(response => {
      console.log("Respone from getData ", response.data)
      if(response && response.data.error){
        alert("Some Technical Error Occurred!")
      }

      if (response && response.status == 200) {

        // _.each(data, (resEachPatient) => {

        _.each(response.data, (resAllEmployee) => {

          if (data.id == resAllEmployee.company[0]) {

            custIdArr.push(resAllEmployee);

          }

        })
        setPatArr(custIdArr);

      }
    })


  }

  // function addEmployee() {

  //   console.log("addEmployee");

  //   history.push({ pathname: `/vertical/addEmployee`, state: data });
  // }

  const { doctor } = useGetDoctor('Dr. Sophie');
  //usePageData(pageData);
  console.log("count", count);
  console.log("dat", dat);
  // console.log("data", data);
  console.log("patArr", patArr);
  return (
    // doctor && (
    <div style={{ padding: 20 }}>
      <h3 style={{ textAlign: 'left' }}>Company Information</h3>

      {loader ?
        <div style={{ margin: "auto" }}>
          <div className='row'>
            <div className='col-md-6 col-sm-12'>

              <div className='info'>
                <DoctorForm doctor={DataAll.length > 0 && DataAll[0]} />
              </div>

            </div>

            <div className='col-md-6 col-sm-12'>

              <Card>
                <DocTimeline dataParentToChild={count} />
              </Card>
            </div>

          </div>

          <div className='row' style={{ marginTop: 0 }}>
            <div className='col-md-12 col-sm-12'>
              <div>
                <Row>
                  <Col span={10}>
                    <h4 style={{ textAlign: 'left' }}>Locations</h4>
                  </Col>
                  <Col span={8}>

                  </Col>
                </Row>

                <Table columns={columnsNew}
                  dataSource={countNew}
                //onChange={onChange} 

                />
              </div>
            </div>
          </div>

          {/* <div className='row'>
            
            <div className='col-md-12 col-sm-12' style={{border:'1px solid grey',borderRadius:25,padding:50,marginTop:30}}>
              <div>
                <Row>
                  <Col span={24}>
                    <h4 style={{ textAlign: 'left' }}>Protocol - Authorization REQUIRED and Documentation</h4>
                  </Col>
                  
                </Row>
<div>
<ProtocolForm protValue={DataAll.length>0 && DataAll[0]} />
                
                <br/>

                <Table columns={colNew}
                  dataSource={arrNewn}
                //onChange={onChange} 

                />
                </div>

                
              </div>
            </div>
          </div> */}

          <div className='row'>
            <div className='col-md-12 col-sm-12'>
              <div>
                <Row>
                  <Col span={4}>
                    <h4 style={{ textAlign: 'left' }}>Employee List</h4>
                  </Col>
                  <Col span={8}>
                    {/* <Tooltip placement="top" title="Add Employee">
                      <PlusCircleTwoTone style={{ fontSize: 25, marginTop: 25, cursor: 'pointer' }} onClick={addEmployee} />
                    </Tooltip> */}

                  </Col>
                </Row>

                <Table columns={columns}
                  dataSource={patArr}
                //onChange={onChange} 

                />
              </div>
            </div>
          </div>
          {/* <div className='row'>
            <div className='col-md-12 col-sm-12'>
              <div>
                <Row>
                  <Col span={10}>
                    <h4 style={{ textAlign: 'left' }}>Pool Generated</h4>
                  </Col>
                  <Col span={8}>
                    

                  </Col>
                </Row>

                <Table columns={colPool}
                  dataSource={poolArr}
                //onChange={onChange} 

                />
              </div>
            </div>
          </div> */}
        </div>
        :
        <Row>
          <Col span={10}>
          </Col>
          <Col span={8}>
            <Space size="middle" style={{ marginTop: 10 }}>

              <Spin size="large" />
            </Space>
          </Col>


        </Row>


      }

    </div>

  );
};

export default DoctorProfilePage;
